import React from "react";
import { connect } from "react-redux";
import { openPanel } from "../../Redux/Panels/RightPanel/actions";
import { closePanel } from "../../Redux/User/actions";
import CreditCard from "../../Components/creditCard";
import { toMoney } from "../../Components/Functions";
import { loggedUser } from "../../Constants/menus";
import { alertNotify, alertAlertify } from "../../Components/Functions";

import Api from "../../Server/Api";
import InfoActionPage from "../../Components/InfoActionPage";
const api = new Api();

const BankWithdrawalForm = (props) => {
	const [amount, setAmount] = React.useState();
	const [loading, setLoading] = React.useState(false);
	const [DATA, setDATA] = React.useState("");
	const [btnText, setBtnText] = React.useState("Continue");
	const [isCompleted, setIsCompleted] = React.useState(false);
	const [showOtp, setShowOtp] = React.useState(false);
	const [otpCode, setOtpCode] = React.useState("");
	const [withdrawNote, setWithdrawNote] = React.useState("");

	const validateAmount = (e) => {
		if (parseInt(e.target.value) < 0) {
			e.target.value = "";
		} else if (parseInt(e.target.value) === 0) {
			e.target.value = "";
		}
		if (parseInt(e.target.value) > props?.user?.user?.wallet?.balance) {
			alertNotify({
				message: "Amount greater than your current balance!",
				type: "error",
				timeout: 3,
			});
			e.target.value = e.target.value.slice(0, -1);
		}
		setAmount(parseInt(e.target.value));
	};

	const canContinue = React.useMemo(() => {
		return amount > 1000 && amount <= props?.user?.user?.wallet?.balance  && withdrawNote;
	}, [amount, props?.user?.user?.wallet?.balance, withdrawNote]);

	const generateOTP = async () => {
		setLoading(true);
		let res = await api.get({ endpoint: `/transactions/verify_transaction/` });
		setLoading(false);
		if (res?.otp_secret) {
			alertNotify({
				message:`Please enter the OTP code sent your email`,
				type: "success",
				timeout: 15,
			});
			setDATA(res);
			setBtnText("Withdraw");
			setShowOtp(true);
			return;
		}
		alertNotify({
			message:
				"Something is wrong, please try again later or contact the adminstrator",
			type: "error",
			timeout: 5,
		});
		return;
	};

	const makeWithdrawal = async (e) => {
		if (amount < 1000) {
			alertNotify({
				message: "The minimum withdrawal amount is #1000",
				type: "error",
				timeout: 5,
			});
			return;
		}
		if (btnText === "Continue") {
			generateOTP();
			return;
		}
		setLoading(true);
		let res = await api.post({
			endpoint: `/transactions/`,
			data: {
				amount: amount,
				note: withdrawNote,
				otp_code: otpCode,
				secret: DATA.otp_secret,
			},
		});
		setLoading(false);
		if (res?.id) {
			setIsCompleted(true);
			alertAlertify({
				title: "Withdrawal successful",
				message: "The transaction is pending.",
				btnCallback: "Ok",
				closable: 0,
				callback: (e) => {
					void 0;
				},
			});
			props.initBanking && props.initBanking()
		}
	};

	if (isCompleted){
		return <InfoActionPage
			title="Withdrawal Request Successful"
			message="Your withdrawal request has been placed, you will receive payment to your bank details as soon as posible!"
		/>;
	  }

	return (
		<div className="ml-2 mr-2">
			<div className="banking-dashboard banking-dashboard-v2 ecommerce-dashboard ecommerce-dashboard-v1">
				{/*Panel*/}
				<div className="dashboard-card is-card-panel p-0">
					<div className="columns is-gapless">
						<div className="column is-6">
							{/*Box*/}
							<div className="inner-box">
								<div className="cards-wrapper">
									<div className="cards-carousel">
										<div className="cards-carousel-inner">
											{/*Carousel Item*/}
											<div className="cards-carousel-item">
												<CreditCard
													name={`@${loggedUser?.username}`}
													balance={toMoney(props?.wallet?.balance)}
													pendingBalance={toMoney(props?.wallet?.pending_balance)}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="form-body p-5"
				style={{
					paddingTop: 0,
				}}
			>
				<style>
					{`
					input[type=number]::-webkit-inner-spin-button, 
					input[type=number]::-webkit-outer-spin-button { 
					  -webkit-appearance: none; 
					}
					
					input[type=number] {
					  -moz-appearance: textfield;
					}					
				`}
				</style>
				<div className="columns is-multiline gh mb-5">
					<div className="w-100">
						<br />
						<label style={{ fontSize: "17px" }}>
							Amount *
							<br />
						</label>
						<input
							type="number"
							class="input"
							maxlength="12"
							onChange={(e) => validateAmount(e)}
						/>
					</div>
				</div>
				<div className="columns is-multiline gh mb-5">
					<div className="w-100">
						<br />
						<label style={{ fontSize: "17px" }}>
							Withdrawal Note *
							<br />
						</label>
						<textarea
							class="input"
							rows="3"
							id="withdrawalNote"
							onInput={(e) => setWithdrawNote(e.target.value)}
							style={{ resize: "none", height: "auto" }}
						/>
					</div>
				</div>
				{showOtp && (
					<div className="columns is-multiline gh mb-5">
						<div className="w-100">
							<input
								class="input"
								onInput={(e) => setOtpCode(e.target.value)}
								placeholder="Enter OTP pin"
								id="otp-pin"
							/>
						</div>
					</div>
				)}
				{canContinue && (
					<div className="columns is-multiline gh mb-5 full-width">
						<button
							className={`button h-button is-primary is-bold is-raised ${
								loading ? "is-loading" : ""
							}`}
							id="withdrawBtn"
							onClick={(e) => makeWithdrawal(e)}
							style={{
								display: "block",
								width: "100%",
							}}
						>
							{btnText}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = ({ user }) => {
	return { bank: user?.user?.bank || {} };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BankWithdrawalForm);
